import { render, staticRenderFns } from "./ItemPreview.vue?vue&type=template&id=04ed9574&"
import script from "./ItemPreview.vue?vue&type=script&lang=js&"
export * from "./ItemPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/datavol/sites/sphir-ui-master/releases/20210903105233/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ed9574')) {
      api.createRecord('04ed9574', component.options)
    } else {
      api.reload('04ed9574', component.options)
    }
    module.hot.accept("./ItemPreview.vue?vue&type=template&id=04ed9574&", function () {
      api.rerender('04ed9574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/components/PostForm/EditAttachments/ItemPreview.vue"
export default component.exports